<span
  [matTooltip]="
    date
      ? isTextCropped
        ? (date?.timestamp | locale : dateFormat : date?.timezone) +
          '&#13;' +
          timezoneText +
          (date?.resolved ? '' : '&#13;' + ('common.message.timezoneIsNotResolved' | translate))
        : timezoneText + (date?.resolved ? '' : '&#13;' + ('common.message.timezoneIsNotResolved' | translate))
      : null
  "
  #wrapper
  class="date-with-timezone__wrap"
>
  <ng-content></ng-content>
  <ui-svg-icon
    *ngIf="date?.resolved === false"
    [name]="iconNames.AlertInfo"
    [width]="16"
    class="timezone-alert tw-align-sub"
  ></ui-svg-icon>
  <ng-container *ngIf="isEmptyStringAvailable; else templateWithNotAvailable">
    {{ date?.timestamp | locale : dateFormat : date?.timezone : null : date?.offset | nullToEmptyStringPipe }}
  </ng-container>
  <ng-template #templateWithNotAvailable>
    <span [ngClass]="{ 'tw-pl-[19px]': isAligningApplicable && date?.resolved }">
      {{ date?.timestamp | locale : dateFormat : date?.timezone : null : date?.offset | nullToNotAvailable }}
    </span>
  </ng-template>
</span>
